export default "__VITE_ASSET__DA$5lESr__"